import React from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { reduxForm, Field, getFormValues } from 'redux-form';
import moment from 'moment';
import { connect } from 'react-redux';

import { SECOND_REVIEW_DETAILS_FORM_NAME } from 'Common/FormEnum';
import { Checkbox, DatePickerField, Select } from 'Common/SemanticWrapper';
import { SecondReviewDetailsEnum as Fields } from 'Common/FieldEnum';
import { createFieldsValidator, isDateValid } from 'Common/FormHelper';

import { SecondReviewOrderBy } from '../helpers/constants';

let SecondReviewDetailsForm = ({ formValues, loading }) => (
  <Form>
    <Grid>
      <Grid.Row>
        <Grid.Column width={4}>
          <Field
            label="From Date"
            component={DatePickerField}
            name={Fields.FromDate}
            type="text"
            disabled={formValues[Fields.AllDates] || loading}
          />
        </Grid.Column>
        <Grid.Column width={4}>
          <Field
            label="To Date"
            name={Fields.ToDate}
            component={DatePickerField}
            type="text"
            disabled={formValues[Fields.AllDates] || loading}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Field
            label={'All Dates'}
            component={Checkbox}
            name={Fields.AllDates}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Field
            label={'Only Show Modified Applications'}
            component={Checkbox}
            name={Fields.OnlyShowModified}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Field
            label="Order By"
            component={Select}
            name={Fields.OrderBy}
            options={SecondReviewOrderBy}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Form>
);

const validator = createFieldsValidator(
  [Fields.OrderBy, Fields.FromDate, Fields.ToDate],
  {
    [Fields.FromDate]: 'Please select a valid date.',
    [Fields.ToDate]: 'Please select a valid date.',
  },
  {
    [Fields.FromDate]: (date, values) =>
      !values[Fields.AllDates] || isDateValid(date),
    [Fields.ToDate]: (date, values) =>
      !values[Fields.AllDates] || isDateValid(date),
  }
);

const validate = values => {
  const errors = {};
  const validatorErrors = validator(values);

  /** If all dates is selected, no need to validate to/from date */
  if (!values[Fields.AllDates]) {
    if (!values[Fields.ToDate]) {
      errors[Fields.ToDate] = 'To Date is required.';
    }

    if (!values[Fields.FromDate]) {
      errors[Fields.FromDate] = 'From Date is required.';
    }

    if (!validatorErrors[Fields.FromDate] && !validatorErrors[Fields.ToDate]) {
      if (
        moment(values[Fields.FromDate]).isAfter(moment(values[Fields.ToDate]))
      ) {
        errors[Fields.ToDate] = 'To Date cannot be a date before From Date.';
        errors[Fields.FromDate] = 'From Date cannot be a date after To Date.';
      }
    }
  }

  return {
    ...validatorErrors,
    ...errors,
  };
};

SecondReviewDetailsForm = reduxForm({
  form: SECOND_REVIEW_DETAILS_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(SecondReviewDetailsForm);

const formSelector = getFormValues(SECOND_REVIEW_DETAILS_FORM_NAME);

const mapStateToProps = state => ({
  formValues: formSelector(state) || {},
});

SecondReviewDetailsForm = connect(mapStateToProps)(SecondReviewDetailsForm);

export { SecondReviewDetailsForm };



// WEBPACK FOOTER //
// ./src/pages/secondreviewdetails/components/SecondReviewDetailsForm.js